$(document).ready(function () {
    "use strict";

    const selectColor = $(".js_selectColor");

    if (selectColor.length > 0) {
        selectColor.click(function() {
            selectColor.removeClass("active");
            $(this).addClass("active");
        })
    }
});
